module.exports = __webpack_public_path__ + "static/media/arrow_circle_up-24px.c71c535c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/arrow_circle_up-24px.svg
// module id = 3361
// module chunks = 0